import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { NavLink } from 'fluxible-router';
import styles from './styles.module.styl';

const CuratedCard = (props) => {
  const { category, articleCount } = props;

  const articles = _.take(category.articles, articleCount);
  
  return (
    <div className={`${styles.curatedCard} col-sm-6 col-md-4`}>
      <div className={styles.curatedCardContainer}>
        <div className={styles.curatedCardLogo}>
          <img src={`/docs/img/curated/${category.id}.png`} />
        </div>

        <div className={`${styles.curatedCardMain}`}>
          <div className={styles.curatedCardHeader}>
            <h3>
              <NavLink href={category.url}>
                {category.title}
              </NavLink>
            </h3>

            <p>{category.description}</p>
          </div>

          <ul className={styles.curatedCardArticles}>
            {articles.map(article => (
              <li key={article.url}>
                <NavLink href={article.url} followLink={article.forceFullReload}>
                  {article.title}
                </NavLink>
              </li>
            ))}
          </ul>

          <NavLink className={styles.curatedCardMore} href={category.url}>+ More</NavLink>
        </div>
      </div>
    </div>
  );
};

CuratedCard.defaultProps = {
  articleCount: 3
};

CuratedCard.propTypes = {
  category: PropTypes.object,
  articleCount: PropTypes.number.isRequired
}

export default CuratedCard;
